<template>
  <div class="item shadow"
       :class="{'item-transferable': this.transferTarget && item.canTransferTo(this.transferTarget.characterId), duplicate: item.isDuplicate}"
       :style="{'background': this.background}"
       @dblclick.stop="debugItem"
       @click.stop="transferItem"
       :title="item.definition.displayProperties.description"
  >
    <tags-selector v-if="tagsSelectorVisible" @close="tagsSelectorVisible = false" :item="item">
      <h2 slot="header">foo bar</h2>
    </tags-selector>
    <div class="image-container">
      <img class="item-image" :src="item.icon"
           @click.stop=" item.data.itemInstanceId?$router.push({name: 'item', params: {instanceId: item.data.itemInstanceId}}):false">
      <div class="quantity" v-show="item.data.quantity>1">{{ item.data.quantity }}</div>
    </div>

    <div class="description">
      <div class="name">
        {{ item.name }}
      </div>
      <div class="type-name">
        {{ item.definition.itemTypeDisplayName }}, {{ item.bucket.displayProperties.name}}
      </div>
    </div>
    <span class="class-name">
      {{ item.character.className }}
    </span>
    <div class="primary-stat" v-if="item.primaryStat" :class="[item.damageTypeName.toLowerCase()]">
      <div>
        <img v-if="item.damageType.showIcon" :src="item.damageTypeIcon">
        {{ item.primaryStat }}
      </div>
      <div class="real" title="Power level without mod">
        ({{ item.realPrimaryStat }})
      </div>
    </div>
    <div class="icons-small">
      <div class="icon equipped" v-show="item.canEquip">
        <i v-show="item.equipped" class="material-icons" @click.stop="unEquip">bookmark</i>
        <i v-show="!item.equipped" class="material-icons" @click.stop="equip">bookmark_border</i>
      </div>
      <div v-show="item.key" class="icon favorite">
        <i v-show="item.favorited" class="material-icons" @click.stop="unFavorite">star</i>
        <i v-show="!item.favorited" class="material-icons" @click.stop="favorite">star_border</i>
      </div>
      <div v-show="item.canToggleLock" class="icon lock">
        <i v-show="item.isLocked" class="material-icons" @click.stop="unLock">lock</i>
        <i v-show="!item.isLocked" class="material-icons" @click.stop="lock">lock_open</i>
      </div>
    </div>

    <div class="sockets">
      <div class="socket" v-for="socket in item.displayableSockets">
        <img :src="'//www.bungie.net' + socket.displayProperties.icon" :title="socket.displayProperties.name">
      </div>
    </div>
    <div class="icons">
      <div v-show="item.key" class="icon">
        <i class="material-icons" @click.stop="showTagsSelector">menu</i>
      </div>
    </div>

  </div>
</template>

<script>
  import TagsSelector from './TagsSelector.vue'

  export default {
    components: {TagsSelector},
    name: 'item',
    props: ['item', 'character'],
    data () {
      return {
        transfering: false,
        tagsSelectorVisible: false
      }
    },
    computed: {
      background () {
        const background = this.item.isTransferable ? '#34404d' : '#2A333E'
        const tags = this.item.tags
        if (tags.length) {
          const gradient = this.item.tags
            .map(tag => this.tagColor(tag))
            .reduce((acc, cur) => {
              acc.push(cur)
              acc.push(cur)
              return acc
            }, [])
            .concat(background)
            .map((color, i) => color + ' ' + (Math.ceil(i / 2) * 10) + 'px')
            .join(',')
          const back = `linear-gradient(-45deg, ${gradient})`
          return back
        } else {
          return background
        }
      },
      transferTarget () {
        const targetCharacter = this.character || this.$store.state.destiny.profile.selectedCharacter
        return this.$store.getters['destiny/profile/getCharacter'](targetCharacter)
      }
    },
    methods: {
      tagColor (tag) {
        return this.$store.state.tagsDefinitions[tag].color
      },
      transferItem () {
        if (this.transferTarget && this.item.canTransferTo(this.transferTarget.characterId)) {
          this.item.transfer(this.transferTarget).then(() => {
            this.$ga.event({
              eventCategory: 'item',
              eventAction: 'transferItem',
              eventLabel: this.item.name,
              eventValue: 1
            })
          }).catch(error => {
            this.$store.dispatch('errors/pushError', {error: error.message})
          })
        }
      },
      equip () {
        this.item.equip().then(() => {
          this.$ga.event({
            eventCategory: 'item',
            eventAction: 'equipItem',
            eventLabel: this.item.name,
            eventValue: 1
          })
        }).catch(error => {
          this.$store.dispatch('errors/pushError', {error: error.message})
        })
      },
      unEquip () {
        this.item.unEquip().then(() => {
          this.$ga.event({
            eventCategory: 'item',
            eventAction: 'unEquipItem',
            eventLabel: this.item.name,
            eventValue: 1
          })
        }).catch(error => {
          this.$store.dispatch('errors/pushError', {error: error.message})
        })
      },
      lock () {
        this.item.lock().then(() => {
          this.$ga.event({
            eventCategory: 'item',
            eventAction: 'lockItem',
            eventLabel: this.item.name,
            eventValue: 1
          })
        }).catch(error => {
          this.$store.dispatch('errors/pushError', {error: error.message})
        })
      },
      unLock () {
        this.item.unLock().then(() => {
          this.$ga.event({
            eventCategory: 'item',
            eventAction: 'unLockItem',
            eventLabel: this.item.name,
            eventValue: 1
          })
        }).catch(error => {
          this.$store.dispatch('errors/pushError', {error: error.message})
        })
      },
      favorite () {
        this.$store.commit('favoriteItem', {item: this.item})
        this.$ga.event({
          eventCategory: 'item',
          eventAction: 'favorite',
          eventLabel: this.item.name,
          eventValue: 1
        })
      },
      unFavorite () {
        this.$store.commit('unFavoriteItem', {item: this.item})
        this.$ga.event({
          eventCategory: 'item',
          eventAction: 'unFavorite',
          eventLabel: this.item.name,
          eventValue: 1
        })
      },
      showTagsSelector () {
        this.tagsSelectorVisible = true
      },
      debugItem () {
        window.item = this.item
      }
    }
  }
</script>

<style lang="scss">
  @import "../styles/settings";

  .item {
    position: relative;
    height: 50px;
    overflow: hidden;
    &.duplicate {
      /* border-right: 5px solid lighten($item-color, 5%); */
    }
    background: lighten($background, 5%);
    &.item-transferable {
      cursor: pointer;
      background: $background;

    }
    font-size: 1rem;
    color: rgba(255, 255, 255, .8);
    margin: .5rem;
    display: flex;
    align-items: center;

    opacity: 0.7;
    transition: opacity 0.2s ease-in-out;
    &:hover {
      opacity: 1;
    }
    .image-container {
      height: 50px;
      position: relative;
      .item-image {
        flex-basis: 50px;
        width: 50px;
        height: 50px;
        flex-grow: 0;
        flex-shrink: 0;
      }
      .quantity {
        position: absolute;
        bottom: 0;
        right: 2px;
        font-weight: bold;
        text-shadow: $default-text-shadow;
      }
    }

    .description {
      position: relative;
      flex-grow: 1;
      flex-shrink: 1;
      font-size: 1rem;
      font-weight: 400;
      padding: 0 1rem;
      .name {
        top: -1.3rem;
      }
      .type-name {
        font-size: 0.8rem;
        font-weight: 100;
      }
      .name, .type-name {
        position: absolute;
        width: 100%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .primary-stat, .class-name {
      padding: 1rem 0.5rem;
      white-space: nowrap;
      &.arc {
        color: $arc;
      }
      &.solar {
        color: $solar;
      }
      &.void {
        color: $void;
      }
      .real {
        font-size: 75%
      }
    }
    .primary-stat {
      text-align: right;
      flex-basis: 40px;
      flex-shrink: 0;
      flex-grow: 0;
      img {
        width: 0.7rem;
      }
    }
    .owner {
      display: block;
      flex-basis: 120px;
      flex-shrink: 0;
    }
    .icons-small {
      height: 50px;
      display: flex;
      //flex-wrap: wrap;
      flex-direction: column;
      .icon {
        height: 12px;
        width: 12px;
        cursor: pointer;
        .material-icons {
          font-size: 12px;
          vertical-align: text-bottom;
        }
      }

    }
    .icons {
      max-height: 50px;
      max-width: 30px;
      display: flex;
      flex-wrap: wrap;

      .icon {
        height: 50px;
        width: 50px;
        cursor: pointer;
        z-index: 5;
        line-height: 50px;

        .material-icons {
          line-height: 50px;
          font-size: 30px;
          vertical-align: middle;
        }
        transition: all 0.2s ease-in-out;
        &:hover {
          color: rgba(255, 255, 255, 1);
          .material-icons {

          }
        }

      }
    }
    .sockets {
      margin-left: 0.5rem;
      height: 50px;
      width: 50px;
      display: flex;
      flex-wrap: wrap;
      overflow: hidden;
      .socket {
        height: 25px;
        margin: 0;
        padding: 0;
        img {
          height: 25px;

        }
      }
    }
    .tag-badge {
      position: absolute;
      top: 0;
      bottom: 0;
      float: right;
    }

  }

</style>



// WEBPACK FOOTER //
// Item.vue?2400f1d8